import { Suspense, useEffect } from 'react';

import { Outlet } from 'react-router';

import { Loader } from '@/components/ui/loader';
import { useResetSessionState } from '@/features/auth/auth.hooks';
import { RouteErrorBoundary } from './route-error-boundary';

const BaseLayout = () => {
  const resetSessionState = useResetSessionState();

  // Every way out of a session lands here (logout, a failed logout, an
  // expired session), and by the time this mounts the CMS page has unmounted, so the
  // last operator's data can go without anything refetching it.
  useEffect(() => {
    resetSessionState();
  }, [resetSessionState]);

  return (
    <main className="bg-neutral-90">
      <RouteErrorBoundary>
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center">
              <Loader />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </RouteErrorBoundary>
    </main>
  );
};

export default BaseLayout;
